import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill="transparent"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M7.66667 8.66732V2.00065C7.66667 1.63246 7.36819 1.33398 7 1.33398H1.66667C1.29848 1.33398 1 1.63246 1 2.00065V8.66732C1 9.03551 1.29848 9.33398 1.66667 9.33398H2.33333M7.66667 8.66732C7.66667 9.03551 7.36819 9.33398 7 9.33398H5M7.66667 8.66732L7.66667 3.33398C7.66667 2.96579 7.96514 2.66732 8.33333 2.66732H10.0572C10.234 2.66732 10.4036 2.73756 10.5286 2.86258L12.8047 5.13872C12.9298 5.26375 13 5.43332 13 5.61013V8.66732C13 9.03551 12.7015 9.33398 12.3333 9.33398H11.6667M7.66667 8.66732C7.66667 9.03551 7.96514 9.33398 8.33333 9.33398H9M2.33333 9.33398C2.33333 10.0704 2.93029 10.6673 3.66667 10.6673C4.40305 10.6673 5 10.0704 5 9.33398M2.33333 9.33398C2.33333 8.5976 2.93029 8.00065 3.66667 8.00065C4.40305 8.00065 5 8.5976 5 9.33398M9 9.33398C9 10.0704 9.59695 10.6673 10.3333 10.6673C11.0697 10.6673 11.6667 10.0704 11.6667 9.33398M9 9.33398C9 8.5976 9.59695 8.00065 10.3333 8.00065C11.0697 8.00065 11.6667 8.5976 11.6667 9.33398" />
  </svg>
);
